export default [
    {path: 'upload'},
]